<style scoped lang="less">
  .common-upload {

    .upload-list {
      margin: 5px 0;
      display: inline-block;
      width: 60px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      border: 1px solid transparent;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
      position: relative;
      box-shadow: 0 1px 1px rgba(0, 0, 0, .2);

      img {
        width: 100%;
        height: 100%;
      }
    }
    .upload-list-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, .4);
    }
    .upload-list:hover .upload-list-cover {
      display: block;
    }
    .upload-list-cover i {
      color: #fff;
      font-size: 20px;
      cursor: pointer;
      margin: 0 2px;
    }

    .carousel-mask {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-color: rgba(55, 55, 55, .6);
      height: 100%;
      z-index: 2000;
    }
    .carousel-wrapper {
      position: fixed;
      overflow: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2001;
      outline: 0;

      .carousel-content {
        position: relative;
        margin: 20px auto;
        width: 800px;
        height: 600px;

        img {
          max-width: 800px;
          max-height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
</style>
<template>
  <div class="common-upload">
    <Upload ref="upload" :with-credentials=true :headers="headers" :data="data" :show-upload-list=false
            :multiple="false"
            :on-success="onSuccess"
            :before-upload="beforeUpload"
            :accept="accept" :action="action">
      <div style="padding: 10px 0">
        <Button type="ghost" icon="ios-cloud-upload-outline">{{text}}</Button>
      </div>
      <!--<template v-if="progress">-->
        <!--<Progress v-if="item.showProgress" :percent="item.percentage"></Progress>-->
      <!--</template>-->
    </Upload>
  </div>
</template>
<script>
  export default {
    name: 'SingleOnePicUpload',
    props: {
      text: {
        type: String,
        default () {
          return '点击上传'
        }
      },
      params: {
        type: Object,
        default () {
          return {bucket: 'hellokid'}
        }
      },
      accept: {
        type: String,
        default () {
          return 'image/*'
        }
      },
    },
    data () {
      return {
        action: '',
        headers: {},
        data: this.params,
        largeImageUrl: '',
        progress: false
      }
    },
    methods: {
      onSuccess (res, file, fileList) {
        this.$Message.info('上传成功')

        file.url = res.data.url
        file.name = res.data.name
        file.fileId = res.data.fileId
        file.size = res.data.size

        this.emitInput(file)
      },
      beforeUpload () {
        this.headers.token = this.$store.get('token')
        if (this.$store.get('account') && this.$store.get('password')) {
          this.headers.account = this.$store.get('account')
          this.headers.password = this.$store.get('password')
        }

        this.$Message.loading('服务器正在处理中...', 0)
        return true
      },
      emitInput (file) {
        this.$emit('on-file-change', file)
      },
    },
    watch: {
    },
    created: function () {
      this.action = this.$appConfig.baseUrl + '/upload/fileUpload'
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// SingleOnePicUpload.vue?532f7ab4